import Winner from "./Winner";

export default Winner;